import React, { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { ClipboardList } from 'lucide-react';
import QuestionDisplay from './QuestionDisplay';
import { submitSurveyResponses } from '../utils/serverComm';
import { toast } from 'react-toastify';

function SurveyViewer({ title, questions, surveyId, onSubmitSuccess }) {
  const [answers, setAnswers] = useState({});
  const [respondentId, setRespondentId] = useState(null);

  useEffect(() => {
    // Get or create respondent ID
    const storedRespondentId = localStorage.getItem('survey_respondent_id');
    if (storedRespondentId) {
      setRespondentId(storedRespondentId);
    } else {
      const newRespondentId = uuidv4();
      localStorage.setItem('survey_respondent_id', newRespondentId);
      setRespondentId(newRespondentId);
    }
  }, []);

  const handleInputChange = (questionIndex, value, type, questionId) => {
    if (type === 'checkbox-list') {
      // For checkboxes, maintain an array of selected values
      setAnswers(prev => ({
        ...prev,
        [questionId]: {
          ...prev[questionId],
          [value]: !((prev[questionId] || {})[value])
        }
      }));
    } else {
      // For other input types, store the value directly
      setAnswers(prev => ({
        ...prev,
        [questionId]: value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!surveyId) {
      console.error('No surveyId available');
      toast.error('Cannot submit survey: Missing survey ID');
      return;
    }
    
    try {
      await submitSurveyResponses(surveyId, answers, respondentId);
      setAnswers({});
      toast.success('Survey submitted successfully!');
      if (onSubmitSuccess) {
        onSubmitSuccess();
      }
    } catch (error) {
      console.error('Failed to submit survey:', error);
      toast.error('Failed to submit survey. Please try again.');
    }
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold mb-6">{title}</h1>
      {questions.map((question, index) => (
        <QuestionDisplay
          key={index}
          question={question}
          index={index}
          answers={answers}
          handleInputChange={handleInputChange}
          isAdmin={false}
        />
      ))}
      <div className="flex justify-end">
        <button
          onClick={handleSubmit}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Submit Survey
        </button>
      </div>
    </div>
  );
}

export default SurveyViewer; 